import React from 'react'
import ImageComponent from './image'

const SectionProgramComponent = props =>
    <div className="section--primary" id="register">
        <div className="section__grid">
            <div className="section__text">
                <h2>Program</h2>
                <p>The program will be defined and uploaded once the abstracts will be selected</p>
            </div>
            <div className="section__text u-text-center">
                <div className="u-text-center">
                    <p className="c-grid--thirds">
                        <ImageComponent class="c-column-offset" image="pdf-inverted" />
                    </p>
                    <p>
                        <span className="c-btn--fourth" href="#" target="_blank">Coming soon</span>
                    </p>
                </div>
            </div>
        </div>
    </div>

export default SectionProgramComponent



// WEBPACK FOOTER //
// ./src/components/section-program.js